window.addEventListener('load', function () {
  const _learnq = window._learnq = window._learnq || [];

  function addedToCart(item = {}) {
    fetch(`${window.location.origin}/cart.js`)
      .then((res) => res.json())
      .then((data) => {
        const cart = {
          total_price: data.total_price / 100,
          $value: data.total_price / 100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price / 100,
          items: data.items,
          ...item,
        };

        _learnq.push(['track', 'Added to Cart', cart]);
      })
      .catch(function () {});
  }

  document.addEventListener('variant:add', function (event) {
    addedToCart(event.detail?.variant || {});
  });
});
